export const topResults = "fQMVRc";
export const allResults = "xDqb0b";
export const pinned = "Oy$hOd";
export default {topResults,allResults,pinned};